import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accountSocial: []
  },
  mutations: {
    SET_ACCOUNT_SOCIAL (store, items) {
      store.accounts.selectIds = items
    }
  },
  getters: {
    getAccountSocial: (store, getters) => {
      return store.accounts.accountSocial
    }
  },
  actions: {
    /*
    selectAccountSocial
    */
    selectAccountSocial ({commit, dispatch, getters, state}, filters) {
      return dispatch('getAccountSocial', filters).then((response) => {
        commit('SET_ACCOUNT_SOCIAL', response)
        return response
      })
    },
    /*
    getAccountSocial
    */
    getAccountSocial ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}/account-social`)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateAccountSocial
    */
    updateAccountSocial ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-social`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountSocial.js